module.exports = __webpack_public_path__ + "img/图层 68.9d81d4ec.png";